<ng-template>
  <ui-input-number-group [uiAddOnBefore]="inputPrefix" [uiAddOnAfter]="inputSuffix" [uiAddonStyle]="{ maxWidth: '130px' }" uiSize="large">
    <ui-input-number
      [uiId]="controlId"
      [a11yLabelledby]="labelId"
      [formControl]="formControl"
      [uiAutoFocus]="autofocus"
      [a11yDisabled]="disabled"
      [a11yRequired]="required"
      [uiPlaceHolder]="placeholder"
      [uiBorderless]="borderless"
      [a11yDescription]="ariaDescription"
      uiSize="large"></ui-input-number>
  </ui-input-number-group>
</ng-template>
